import { FC } from 'react';

import { GiftCouponSummary } from '@shared/api/giftCoupon/giftCoupon.interface';

interface CourtesySectionProps {
  courtesyMode: boolean;
  setCourtesyMode: (v: boolean) => void;
  /** 수신번호 있는 발송 대상 후보 */
  courtesyEligibleCoupons: GiftCouponSummary[];
  courtesySelectedIds: Set<string>;
  setCourtesySelectedIds: (v: Set<string>) => void;
  toggleCourtesySelectAll: () => void;
  setShowCourtesyModal: (v: boolean) => void;
}

/**
 * 답례 인사 일괄 발송 진입 섹션.
 * - 비활성: "답례 인사 보내기" → courtesyMode 켜면 테이블에 답례 체크박스 컬럼이 뜬다.
 * - 활성: 수신번호 있는 쿠폰 전체선택 / 선택 건수 표시 / 발송 모달 열기 / 모드 취소.
 */
export const CourtesySection: FC<CourtesySectionProps> = ({
  courtesyMode,
  setCourtesyMode,
  courtesyEligibleCoupons,
  courtesySelectedIds,
  setCourtesySelectedIds,
  toggleCourtesySelectAll,
  setShowCourtesyModal,
}) => {
  const eligibleCount = courtesyEligibleCoupons.length;
  const selectedCount = courtesySelectedIds.size;
  const allSelected = eligibleCount > 0 && selectedCount === eligibleCount;

  return (
    <div className="flex shrink-0 items-center justify-between rounded-lg border border-rose-200 bg-rose-50 px-4 py-2.5">
      <div className="flex items-center gap-3">
        <span className="text-sm font-medium text-rose-800">답례 인사 발송</span>
        {!courtesyMode ? (
          <span className="text-xs text-rose-500">
            수신번호 있는 쿠폰 {eligibleCount}건에 답례글 LMS 발송
          </span>
        ) : (
          <label className="flex cursor-pointer items-center gap-2 text-sm font-medium text-gray-700">
            <input
              type="checkbox"
              checked={allSelected}
              onChange={toggleCourtesySelectAll}
              className="h-4 w-4 rounded border-rose-300 text-rose-600 focus:ring-rose-500"
            />
            번호있는 전체선택 ({eligibleCount}건)
            {selectedCount > 0 && (
              <span className="text-xs font-semibold text-rose-600">
                · {selectedCount}건 선택됨
              </span>
            )}
          </label>
        )}
      </div>

      {!courtesyMode ? (
        <button
          onClick={() => setCourtesyMode(true)}
          disabled={eligibleCount === 0}
          className="rounded-lg bg-rose-600 px-3 py-1.5 text-xs font-bold text-white hover:bg-rose-700 disabled:opacity-50"
          title={
            eligibleCount === 0 ? '수신번호 있는 쿠폰이 없습니다' : undefined
          }
        >
          답례 인사 보내기
        </button>
      ) : (
        <div className="flex items-center gap-2">
          <button
            onClick={() => {
              setCourtesyMode(false);
              setCourtesySelectedIds(new Set());
            }}
            className="rounded-lg border border-rose-300 px-3 py-1.5 text-xs font-medium text-rose-700 hover:bg-rose-100"
          >
            취소
          </button>
          <button
            onClick={() => setShowCourtesyModal(true)}
            disabled={selectedCount === 0}
            className="rounded-lg bg-rose-600 px-4 py-1.5 text-xs font-bold text-white hover:bg-rose-700 disabled:opacity-50"
          >
            발송하기 ({selectedCount}건)
          </button>
        </div>
      )}
    </div>
  );
};
